<template>
  <div class="exportTemp_box">
    <div class="temp_t">
      <div class="temp_t_btn" @click="openDialog">新增模板</div>
      <div class="temp_t_search">
        <el-input
          placeholder="模板名称或描述"
          v-model="searchForm.keyword">
        </el-input>
        <el-select v-model="searchForm.platform" placeholder="模板类型">
          <el-option :label="item" :value="item" v-for="item in platformList"></el-option>
        </el-select>
        <el-select v-model="searchForm.user_id" placeholder="账号" v-if="userRole.key != 'employee'">
          <el-option
            v-for="item in subAccountList"
            :key="item.id"
            :label="`${item.nickname}${item.id == $store.state.userInfo.id ? '(我)' : ''}`"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button class="search_btn" @click="tableSearch">
          搜索 
        </el-button>
      </div>
    </div>
    <div class="temp_classi">
      <div class="temp_classi_item" :class="{active: searchForm.group_id == ''}" @click="changeCategory('')">全部</div>
      <div v-for="(item, index) in classifyList" class="temp_classi_item" :class="{active: searchForm.group_id == item.id}" @click="changeCategory(item.id)">
        <div class="temp_classi_del" @click.stop="deleteCategory(item.id)">
          <i class="el-icon-close"></i>
        </div>
        {{ item.name }} <span>{{ item.num }}</span>
      </div>
      <div class="temp_classi_add" @click="addClassify">新增分类</div>
    </div>
    <el-table
      :data="tableData"
      class="main_table">
      <el-table-column
        type="selection"
        width="55" />
      <el-table-column
        label="模板名称">
        <template slot-scope="scope">
          {{scope.row.name}}
          <span class="table_tags">{{scope.row.platform}}</span>
          <span class="table_tags" v-if="scope.row.is_public">已公开</span>
        </template>
      </el-table-column>
      <el-table-column prop="user.nickname" label="用户" />
      <el-table-column
        prop="create_time"
        label="创建时间" />
      <el-table-column
        prop="update_time"
        label="更新时间" />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEditTemp(scope.row)" v-if="userPermission(scope.row.user.id)">编辑</el-button>
          <el-button type="text" @click="handleCopyTemp(scope.row.id)" v-if="userPermission(scope.row.user.id)">复制</el-button>
          <el-button type="text" @click="handleRemoveTemp(scope.row.id, scope.row.group_id)" v-if="userPermission(scope.row.user.id)">移动到</el-button>
          <el-button type="text" @click="specifyShared(scope.row)" v-if="userPermission(scope.row.user.id)">分享</el-button>
          <el-button type="text" @click.native="handleTemPubic(scope.row.id, scope.row.is_public)" v-if="userPermission(scope.row.user.id)">{{scope.row.is_public ? '取消公开' : '设为公开'}}</el-button>
          <el-button type="text" style="color: #F72D2D" @click="handleDeleteTemp(scope.row.id)" v-if="userPermission(scope.row.user.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="main_pagination"
      background
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="searchForm.limit"
      :total="tableTotal">
    </el-pagination>
    <el-dialog class="main_dialog" :show-close="false" :title="ruleForm.id ? '编辑模板' : '新增模板'" width="470px" :visible.sync="dialogVisible">
      <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" hide-required-asterisk>
        <el-form-item label="模板名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请填写模板名称"></el-input>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="模板分组" prop="group_id">
              <el-select v-model="ruleForm.group_id" placeholder="请选择模板分组">
                <el-option :label="item.name" :value="item.id" v-for="item in classifyList"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模板类型" prop="platform">
              <el-select v-model="ruleForm.platform" placeholder="请选择模板类型">
                <el-option :label="item" :value="item" v-for="item in platformList"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="模板文件" prop="path">
          <el-upload
            accept=".xlsx, .xls"
            class="form-uploader"
            action
            :show-file-list="false"
            :http-request="handleUploadExcels">
            <!-- <div v-if="ruleForm.path"> </div> -->
            <div class="uploader_btn"> 
              <i :class="{'el-icon-loading': uploadLoading, 'el-icon-check': ruleForm.path}"></i> 
              {{ruleForm.path ? '重新上传' : '导入表格'}} 
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-button class="dialog_confirm" size="small" @click="handleSubmitForm">确 定</el-button>
      <el-button class="dialog_cancel" size="small" @click="dialogVisible = false">取 消</el-button>
    </el-dialog>
    <el-dialog class="main_dialog excel_dialog" :show-close="false" width="96%" :visible.sync="dialogExcelVisible" destroy-on-close>
      <template slot="title">
        <div class="temp_title"> 
          <span class="temp_platform">{{ ruleForm.platform }}</span> 
          <el-input v-if="showTitleInput" v-model="ruleForm.name" autofocus @keyup.enter.native="showTitleInput = false" @blur="showTitleInput = false"></el-input> 
          <span v-else>{{ ruleForm.name }}</span>
          <i v-if="!showTitleInput" class="el-icon-edit-outline" @click="showTitleInput = true"></i>
        </div>
        <div>
          <el-button @click="dialogExcelVisible = false">取消</el-button>
          <el-button @click="openTempDialog">导入配置</el-button>
          <el-button class="submit_btn" @click="handleSubmitExcel" :loading="saveTempLoading">提交</el-button>
        </div>
      </template>
      <div class="excel_title" v-if="excelContent.overall?.length">全局信息</div>
      <div class="overall_box" v-if="excelContent.overall?.length">
        <div v-for="item in excelContent.overall">
          <span>{{ item.name }}：</span>
          <span class="overall_value">{{ item.value }}</span>
        </div>
      </div>
    <div v-for="tableType in ['base', 'spu', 'sku']" :key="tableType">
      <div class="excel_title"
        v-if="excelContent[tableType]?.length">{{tableType == 'base' ? '基础' : tableType.toLocaleUpperCase()}}信息</div>
      <!-- :key="isUpdatesku" -->
      <div class="skutable_box"
        v-if="excelContent[tableType]?.length">
        <el-table
          :ref="`table${tableType}`"
          :key="isUpdatesku"
          class="main_d_table"
          :data="tableType == 'base' ? baseTableData : tableType == 'spu' ? spuTableData : skuTableData"
          style="width: 100%">
          <el-table-column align="center" :label="item.name" v-for="(item, index) in excelTableHead[tableType]">
            <el-table-column
              v-for="(iten, indey) in item.children"
              :prop="iten.column + ''"
              :label="iten.name"
              :render-header="(h,obj) => renderSkuHeader(h,obj,iten,tableType)"
              width="270">
              <template slot-scope="scope">
                <div v-if="iten.headType == 'fixed'">
                  <el-input v-if="iten.type == 'text'" type="textarea" v-model="scope.row[iten.column].value"></el-input>
                  <el-select v-else-if="iten.type == 'select'" v-model="scope.row[iten.column].value">
                    <el-option :label="ite" :value="ite" v-for="ite in iten.options"></el-option>
                  </el-select>
                </div>
                <div v-else-if="iten.headType == 'dynamics'" class="table_dy_box" :class="{isImg: scope.row[iten.column].value[0] == 'images'}">
                  <el-select v-model="scope.row[iten.column].value[0]" @change="changeDynamics($event, scope.row[iten.column].value)">
                    <el-option :label="ite" :value="key" v-for="(ite, key) in dynamicsOptions"></el-option>
                  </el-select>
                  <el-input type="number" v-if="scope.row[iten.column].value[0] == 'images'" v-model="scope.row[iten.column].value[1]">
                    <span slot="prepend">第</span>
                    <span slot="append">张</span>
                  </el-input>
                </div>
                <div v-else-if="iten.headType == 'multiple'" @click="addMultipleValue(scope.row[iten.column].value, iten.options || [], scope.$index, iten.column, tableType)">
                  <div v-if="scope.row[iten.column].value.length">
                    <el-tag v-for="ittt in scope.row[iten.column].value">
                      {{ittt.type == 'fixed' ? ittt.value : ittt.value[0] == 'images' ? `${dynamicsOptions[ittt.value[0]]}第${ittt.value[1]}张` : dynamicsOptions[ittt.value[0]]}}
                    </el-tag>
                  </div>
                  <div v-else>点击添加值</div>
                </div>
                <div v-else-if="iten.headType == 'spu'">批次号+序号</div>
                <div v-else-if="iten.headType == 'sku'">SPU+序号</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120" v-if="tableType == 'sku'">
            <template slot-scope="scope">
              <el-button type="text" @click="handleAppendSkuTable('copy', scope.row)">复制</el-button>
              <el-button type="text" style="color: #F72D2D" @click="handleDeleteSkuRow(scope.$index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-if="tableType == 'sku'" class="skutable_add" icon="el-icon-plus" circle @click="handleAppendSkuTable('add')"></el-button>
      </div>
    </div>
    </el-dialog>
    <el-dialog class="main_dialog multiple_dialog" :show-close="false" width="600px" :visible.sync="multipleDialog">
      <el-dropdown @command="multipleTypeChange">
        <el-button>添加内容<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="fixed">固定值</el-dropdown-item>
          <el-dropdown-item command="dynamics">动态值</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-if="multipleData.length">
        <div v-for="(item, index) in multipleData" class="multiple_item">
          <el-select v-model="item.type" @change="multipleTypeChange($event, index)" class="multiple_item_type">
            <el-option label="固定值" value="fixed"></el-option>
            <el-option label="动态值" value="dynamics"></el-option>
          </el-select>
          <div v-if="item.type == 'fixed'" class="multiple_item_c">
            <el-select v-if="multipleFixedOptions.length" v-model="item.value">
              <el-option :label="ite" :value="ite" v-for="ite in multipleFixedOptions"></el-option>
            </el-select>
            <el-input v-else v-model="item.value" placeholder="请输入内容"></el-input>
          </div>
          <div v-else class="multiple_item_c" :class="{isImg: item.value[0] == 'images'}">
            <el-select v-model="item.value[0]" @change="changeDynamics($event, item.value)">
              <el-option :label="ite" :value="key" v-for="(ite, key) in dynamicsOptions"></el-option>
            </el-select>
            <el-input type="number" v-if="item.value[0] == 'images'" v-model="item.value[1]">
              <span slot="prepend">第</span>
              <span slot="append">张</span>
            </el-input>
          </div>
          <el-button @click="delMultiple(index)" class="multiple_item_del"><i class="el-icon-minus"></i></el-button>
        </div>
      </div>
      <div>
        <el-button class="dialog_confirm" size="small" @click="handleSubmitMultiple">确 定</el-button>
        <el-button class="dialog_cancel" size="small" @click="multipleDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 指定共享弹窗 -->
    <specify-share ref="specifyShare" pageType="exportTemp" :list="emitChildData" />
    <ExportAccordTemp ref="ExportAccordTempRef" pageType="exportTemp" :templateId="ruleForm.id" @exportNewTemp="handleDealNewTemp" />
  </div>
</template>
<script>
import { tempgroupGetList, tempgroupCreate, tempgroupDelete, tempexportGetList, tempexportCreate, tempexportUpdate, tempexportDetail, tempexportDelete, tempexportCopy, tempexportRemove, tempexportUpload, tempexportParse, tempexportUpdatePublic } from '@/api/exportTemp'
import { allSubGetList } from '@/api/subaccount'
import SpecifyShare from "@/components/SpecifyShare";
import ExportAccordTemp from "@/components/ExportAccordTemp.vue";
export default {
  name: "exportTemp",
  components: {SpecifyShare, ExportAccordTemp},
  data () {
   return {
    subAccountList: [{id: -1, nickname: '全部'}],
    searchForm: {
      keyword: '',
      platform: '',
      group_id: '',
      page: 1,
      limit: 10
    },
    classifyList: [],
    removeClassify: {},
    tableData: [],
    tableTotal: 0,

    dialogVisible: false,
    uploadLoading: false,
    platformList: ['temu', 'tiktok', 'shein', 'shopee'],
    ruleForm: {
      name: '',
      group_id: '',
      platform: '',
      content: {},
      path: ''
    },
    rules: {
      name: [{required: true, message: '请填写模板名称', trigger: 'blur'}],
      group_id: [{required: true, message: '请选择分组', trigger: 'change'}],
      platform: [{required: true, message: '请选择平台类型', trigger: 'change'}],
      path: [{required: true, message: '请上传模板', trigger: 'blur'}],
    },

    dialogExcelVisible: false,
    showTitleInput: false,
    saveTempLoading: false,
    // JSON.parse(localStorage.getItem('excelData1'))
    excelContent: {},
    excelTableHead: {},
    headTypeOptions: {
      fixed: '固定值',
      dynamics: '动态值',
      multiple: '多个值',
      spu: 'SPU货号',
      sku: 'SKU货号'
    },
    dynamicsOptions: {
      images: '结果图',
      original: '原图',
      printing: '印花图',
      title: '原标题',
      cnTitle: '中文标题',
      enTitle: '英文标题',
      name: '名称',
    },
    baseTableData: [{}],
    spuTableData: [{}],
    skuTableData: [{}],
    isUpdatebase: Math.random(),
    isUpdatespu: Math.random(),
    isUpdatesku: Math.random(),

    multipleDialog: false,
    multipleFixedOptions: [],
    multipleData: [],
    multipleRowIndex: 0,
    multipleCurrentColumn: 0,
    multipleTableType: 'base',

    emitChildData: []
   }
  },
  created() {
    if(this.userRole.key != 'employee') {
      this.$set(this.searchForm, 'user_id', -1)
    }
    this.getSubList()
    this.getCategoryList()
    this.getExportTempList()
    // this.dealExcelData(this.excelContent, false)
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole
    }
  },
  methods: {
    userPermission(id) {
      return this.userRole.key != 'employee' || this.$store.state.userInfo.id == id
    },
    forceTableUpdate() {
      this.isUpdatebase = Math.random()
      this.isUpdatespu = Math.random()
      this.isUpdatesku = Math.random()

    },
    openDialog() {
      if(this.ruleForm.id) {
        delete this.ruleForm.id
      }
      this.ruleForm.name = ''
      this.ruleForm.group_id = ''
      this.ruleForm.platform = ''
      this.ruleForm.content = ''
      this.ruleForm.path = ''
      this.baseTableData = [{}]
      this.spuTableData = [{}]
      this.skuTableData = [{}]
      this.excelTableHead['base'] = []
      this.excelTableHead['spu'] = []
      this.excelTableHead['sku'] = []
      this.excelTableHead = {}
      this.forceTableUpdate()
      this.dialogVisible = true
    },
    changeCategory(id) {
      if(id == this.searchForm.group_id) return
      this.searchForm.group_id = id
      this.getExportTempList()
    },
    addClassify() {
      this.$prompt('', '新增分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        inputValidator: (value) => {
          if(!value) {
            return '分类名称不能为空'
          }
        }
      }).then(({ value }) => {
        tempgroupCreate({name: value}).then(res => {
          this.$message.success('创建成功')
          this.getCategoryList()
        })
      })
    },
    deleteCategory(id) {
      this.$confirm('是否删除该分类?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tempgroupDelete(id).then(res => {
          this.$message.success('删除成功')
          this.getCategoryList()
          if(this.searchForm.group_id == id) {
            this.searchForm.group_id = ''
            this.getExportTempList()
          }
        })
      })
    },
    handleUploadExcels(param) {
      this.uploadLoading = true
      let formData = new FormData()
      formData.append('file', param.file)
      tempexportUpload(formData).then(res => {
        this.ruleForm.path = res.data.path
        this.uploadLoading = false
        this.$message.success('上传成功')
      })
    },
    handleEditTemp(row) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // tempexportDetail(row.id).then(res => {})
      this.ruleForm.id = row.id
      this.ruleForm.name = row.name
      this.ruleForm.path = row.path
      this.ruleForm.platform = row.platform
      this.ruleForm.group_id = row.group_id
      this.baseTableData = [{}]
      this.spuTableData = [{}]
      this.skuTableData = [{}]
      this.excelTableHead['base'] = []
      this.excelTableHead['spu'] = []
      this.excelTableHead['sku'] = []
      this.excelTableHead = {}

      this.forceTableUpdate()

      let ddd = JSON.parse(row.content)
      this.dealExcelData(ddd, true)
      this.excelContent = ddd
      setTimeout(() => {
        this.dialogExcelVisible = true
        loading.close();
      }, 1000);
    },
    getInitialValueByType(type) {
      const initialValues = {
        fixed: '',
        dynamics: ['images', 1],
        multiple: [],
        spu: 'spu',
        sku: 'sku'
      }
      return initialValues[type] || ''
    },
    // 导入配置  sku表的行数根据导入模板的行数决定
    handleDealNewTemp(row) {
      const rowContent = JSON.parse(row.content);

      const processValue = (sourceVal, columnConfig) => {
        if(!sourceVal) return null;
        this.$set(columnConfig, 'headType', sourceVal.type)
        // 如果是select的情况
        if (columnConfig.type === 'select' && columnConfig.options && columnConfig.options.length > 0 && columnConfig.headType == 'fixed') {
          const isValidValue = columnConfig.options.includes(sourceVal.value);
          if (!isValidValue) {
            // 如果值不在选项中，使用默认值
            sourceVal.value = '';
          }
        }
        
        // 处理multiple/dynamics类型的数据
        this.dealColumnSingleItem(sourceVal);

        const columnValue = 
          (Array.isArray(sourceVal.value) || (typeof sourceVal.value == 'object' && sourceVal.value !== null))
          ? JSON.parse(JSON.stringify(sourceVal.value))
          : sourceVal.value;
        
        return { type: sourceVal.type, value: columnValue }
      }

      const buildRow = (tableType, sourceRowValues, rowIndex) => {
        const currentHead = this.excelTableHead[tableType]
        const sourceHead = rowContent[tableType]
        const newRow = {}

        // 当前模板的表头
        currentHead.forEach(headGroup => {
          headGroup.children.forEach(columnConfig => {
            // 查找源模板中匹配的表头格式  与当前表头匹配的新表头
            const matchedSourceColumn = sourceHead.find(item => item.head == headGroup.name && item.name == columnConfig.name)

            // 与源模板匹配的项对应的表头配置
            if(matchedSourceColumn) {
              // 匹配的源表头格式对应的源列数据  与新表头匹配的新值
              let sourceValueConfig = sourceRowValues.find(item => item.column == matchedSourceColumn.column)
              const processed = processValue(sourceValueConfig, columnConfig)
              if(processed) {
                newRow[columnConfig.column] = {
                  column: columnConfig.column,
                  type: processed.type,
                  value: processed.value,
                  ...(tableType == 'sku' && { index: rowIndex })
                }
              }else {
                newRow[columnConfig.column] = {
                column: columnConfig.column,
                type: columnConfig.headType,
                value: this.getInitialValueByType(columnConfig.headType),
                ...(tableType == 'sku' && { index: rowIndex })
              };
              }
            }else {
              newRow[columnConfig.column] = {
                column: columnConfig.column,
                type: columnConfig.headType,
                value: this.getInitialValueByType(columnConfig.headType),
                ...(tableType == 'sku' && { index: rowIndex })
              };
            }
          })
        })
        return newRow;
      }

      ['base', 'spu', 'sku'].forEach(tableType => {
        // const currentHead = this.excelTableHead[tableType]
        const sourceHead = rowContent[tableType]
        const sourceValues = rowContent[`${tableType}Values`]

        if(!this.excelTableHead[tableType] || !sourceHead || !sourceValues) return;

        if(tableType == 'sku') {
          this.skuTableData = sourceValues.map((row, idx) => buildRow(tableType, row, idx))
        }else {
          this[`${tableType}TableData`] = [buildRow(tableType, sourceValues, 0)]
        }

      })      
    },
    // 指定分享
    specifyShared(item) {
      //  单文件指定分享时
      if (item) {
        this.emitChildData = [item];
      } else {
        // 多文件指定分享时
        // this.emitChildData = this.multipleSelection;
      }
      this.$refs.specifyShare.dialogVisible = true;
    },
    handleTemPubic(id, is_public) {
      tempexportUpdatePublic({id, is_public: is_public == 1 ? 0 : 1}).then(res => {
        this.$message.success('设置成功')
        this.getExportTempList()
      })
    },
    handleDeleteTemp(id) {
      this.$confirm('是否删除该模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tempexportDelete(id).then(res => {
          this.$message.success('模板删除成功')
          this.getExportTempList()
        })
      })
    },
    handleCopyTemp(id) {
      tempexportCopy(id).then(res => {
        this.$message.success('模板复制成功')
        this.getExportTempList()
      })
    },
    handleRemoveTemp(id, group_id) {
      const h = this.$createElement
      let selectValue = group_id
      let that = this
      this.$msgbox({
        title: '模板移动',
        message: h('el-select', {
          props: {
            value: selectValue
          },
          ref: 'removeSelect',
          style: {width: '100%'},
          on: {
            change: (val) => {
              selectValue = val;
              // 直接更新DOM显示
              that.$refs.removeSelect.value = val
            }
          }
        },[
          that.classifyList.map((item) => 
            h('el-option', {
              props: {
                key: item.id,
                value: item.id,
                label: item.name
              }
            }),
          )
        ]),
        showClose: false,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if(!selectValue) {
              this.$message.warning('请先选择分组');
              return false; // 阻止关闭
            }
            done();
          }else {
            done(); // 取消操作直接关闭
          }
        }
      }).then(action => {
        if (action === 'confirm') {
          tempexportRemove({template_ids: [id], group_id: selectValue}).then(res => {
            this.$message.success('移动成功');
            this.getExportTempList()
          })
        }
      });

    },
    openTempDialog() {
      this.$refs.ExportAccordTempRef.searchForm.platform = this.ruleForm.platform
      this.$refs.ExportAccordTempRef.dialogTempVisible = true
    },
    dealColumnSingleItem(item) {
      if(!item.value) return;

      if(item.type == 'dynamics') {
        let valArr = item.value.split('-')
        item.value = valArr
      }else if(item.type == 'multiple') {
        item.value = JSON.parse(item.value)
        this.dealEditColumnValue(item.value)
      }
    },
    dealEditColumnValue(editData) {
      editData.forEach(item => {
        this.dealColumnSingleItem(item)
      })
    },
    dealExcelData(datas, isEdit) { 
      ['base', 'spu', 'sku'].forEach(key => {
        const columns = datas[key]
        if(!columns || !columns.length) return;

        let childhead = datas[key].reduce((acc, obj) => {
          const head = obj.head
          const sameitem = acc.find(same => same.name == head)

          const headType = isEdit ? (key == 'sku' ? datas[`${key}Values`][0] : datas[`${key}Values`]).find(column => column.column == obj.column)?.type : 'fixed';
          const newobj = {...obj, headType}

          if(sameitem) {
            sameitem.children.push(newobj)
          }else {
            acc.push({name: head, children: [newobj]})
          }
          
          return acc
        }, [])
        this.$set(this.excelTableHead, key, childhead)

        if(!isEdit) {
          columns.forEach(column => {
            const val = column.options?.length == 1 ? column.options[0] : ''
            const columnobj = {column: column.column, type: 'fixed', value: val}
            if(key == 'sku') columnobj.index = 0
            this.$set(this[`${key}TableData`][0], column.column, columnobj)
            // 后面试一下是否有必要加
            // this.$set(column, 'headType', 'fixed');
          })
          this.$set(datas, `${key}Values`, [])
        }else {
          const saved = datas[`${key}Values`];
          if(!saved && !saved.length) return;

          if(key == 'sku') {
            saved.forEach((row, indey) => {
              this.$set(this[`${key}TableData`], indey, {})
              this.dealEditColumnValue(row)
              row.forEach(ite => {
                this.$set(this[`${key}TableData`][indey], ite.column, ite) 
                // const target = columns.find(c => c.column == ite.column)
                // if(target) this.$set(target, 'headType', ite.type)
              })
            })
          }else {
            this.dealEditColumnValue(saved)
            saved.forEach(iten => {
              this.$set(this[`${key}TableData`][0], iten.column, iten) 
              // const target = columns.find(c => c.column == iten.column)
              // if(target) this.$set(target, 'headType', iten.type)
            })
          }
        }
      }) 
    },
    // 新增保存
    handleSubmitForm() {
      this.$refs.ruleForm.validate(valid => {
        if(valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          tempexportParse({path: this.ruleForm.path, platform: this.ruleForm.platform}).then(res => {
            this.dialogExcelVisible = true
            this.dialogVisible = false
            this.dealExcelData(res.data, false)
            this.excelContent = res.data
            loading.close()
          }).catch(() => {
            loading.close()
          })
        }
      })
    },
    // 切换header上的类型
    handleCommand(command, column, type) {
      this.$set(column, 'headType', command)

      // console.log('command', command, column, type, this[`${type}TableData`], this.excelTableHead);
      this[`${type}TableData`].forEach(item => {
        if (item[column.column]) {
          // 只更新受影响的行和列，而不是整个表格数据
          this.$set(item[column.column], 'type', command);
          this.$set(item[column.column], 'value', this.getInitialValueByType(command));
        }
      })
      this.$forceUpdate()
    },
    // 多个值弹窗
    addMultipleValue(data, fixedOptions, index, column, type) {
      this.multipleData = [...data]
      this.multipleFixedOptions = fixedOptions
      this.multipleRowIndex = index
      this.multipleCurrentColumn = column
      this.multipleTableType = type
      this.multipleDialog = true
    },
    multipleTypeChange(val, index) {
      if(!isNaN(index)) {
        this.multipleData[index].value = this.getInitialValueByType(val)
      }else {
        this.multipleData.push({type: val, value: this.getInitialValueByType(val)})
      }
      
    },
    changeDynamics(val, data) {
      if(val == 'images') {
        this.$set(data, 0, val)
        this.$set(data, 1, 1)
      }else {
        this.$set(data, 0, val)
        data.splice(1,1)
      }
    },
    handleSubmitMultiple() {
      this[`${this.multipleTableType}TableData`][this.multipleRowIndex][this.multipleCurrentColumn].value = [...this.multipleData]
      this.multipleDialog = false
    },
    delMultiple(index) {
      this.multipleData.splice(index, 1)
    },
    handleAppendSkuTable(type, rows) {
      let row = JSON.parse(JSON.stringify(type == 'copy' ? rows : this.skuTableData[0]))
      if(type != 'copy') {
        Object.keys(row).forEach(key => {
          this.$set(row[key], 'value', this.getInitialValueByType(row[key].type))
          row[key].index = this.skuTableData.length
        }) 
      }
      this.skuTableData.push(row)
    },
    handleDeleteSkuRow(index) {
      this.skuTableData.splice(index, 1)
    },
    dealSumitData(submitData) {
      submitData.forEach(item => {
        if(item.type == 'dynamics') {
          if(item.value[0] == 'images') {
            item.value = item.value[0] + '-' + item.value[1]
          }else {
            item.value = item.value[0]
          }
        }else if(item.type == 'multiple') {
          this.dealSumitData(item.value)
          item.value = JSON.stringify(item.value)
        }
      })
    },
    handleSubmitExcel() {
      this.saveTempLoading = true
      let baseData = Object.values(JSON.parse(JSON.stringify(this.baseTableData[0]))) 
      let spuData = Object.values(JSON.parse(JSON.stringify(this.spuTableData[0]))) 
      this.dealSumitData(baseData)
      this.dealSumitData(spuData)
      this.excelContent.baseValues = baseData
      this.excelContent.spuValues = spuData
      this.excelContent.skuValues = []
      this.skuTableData.forEach((item, index) => {
        let skuData = Object.values(JSON.parse(JSON.stringify(item))) 
        this.dealSumitData(skuData)
        this.excelContent.skuValues[index] = skuData
      })
      this.ruleForm.content = this.excelContent

      if(this.ruleForm.id) {
        tempexportUpdate(this.ruleForm.id, this.ruleForm).then(res => {
          this.saveTempLoading = false
          this.$message.success('编辑模板成功')
          this.dialogExcelVisible = false
          this.getExportTempList()
        })
      }else {
        tempexportCreate(this.ruleForm).then(res => {
          this.saveTempLoading = false
          this.$message.success('创建模板成功')
          this.dialogExcelVisible = false
          this.getExportTempList()
        })
      }
    },
    getCategoryList() {
      tempgroupGetList({page: 1, limit: 50}).then(res => {
        this.classifyList = res.data.data
      })
    },
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.getExportTempList()
    },
    tableSearch() {
      this.searchForm.page = 1
      this.getExportTempList()
    },
    getExportTempList() {
      tempexportGetList(this.searchForm).then(res => {
        this.tableData = res.data.data
        this.tableTotal = res.data.total
      })
    },
    // fixed="right" 复制的headerDOM没有把el-dropdown的事件绑到复制的DOM上 
    renderSkuHeader(h, {column, $index}, iten, tableType) {
      return h('div', {
        class: 'temp_table_header'
      },[
        h('div', [
          iten.required ? h('span', {style: 'color: #ff4d4f;'}, '*') : null,
          column.label,
        ]),
        h('div', [
          iten.remark ? h('el-popover', {
            props: {
              key: iten.column,
              placement:"top",
              width:"350",
              trigger:"hover",
              content: iten.remark
            }
          },[
            h('i', {
              slot: 'reference',
              class: 'el-icon-question'
            })
          ]) : null,
          h('el-dropdown', {
            props: {
              trigger: 'click',
              // placement: 'bottom-end'
            },
            on: {
              click: (e) => e.stopPropagation(),
              'command': (command) => this.handleCommand(command, iten, tableType)
            }
          }, [
            h('span', {
              class: 'el-dropdown-link'
            }, [
              this.headTypeOptions[iten.headType],
              h('i', { class: 'el-icon-arrow-down el-icon--right' })
            ]),
            h('el-dropdown-menu', {
              slot: 'dropdown'
            }, 
            Object.entries(this.headTypeOptions).map(([key, type]) => 
              h('el-dropdown-item', { props: { command: key } }, type)
            )
            )
          ])
        ])
      ]) 
    },
    getSubList() {
      allSubGetList().then(res => {
        this.subAccountList = this.subAccountList.concat(res.data)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.exportTemp_box {
  border-radius: 4px;
  background: #FFFFFF;
  padding: 24px 16px;
  .temp_t {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .temp_t_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      font-size: 20px;
      font-weight: 500;
      color: #F7F8FA;
      width: 171px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }
    .temp_t_search {
      // width: 321px;
      margin-right: 20px;
      display: flex;
      gap: 16px;
      /deep/ .el-input__inner {
        border-radius: 8px;
        background: #F2F3F5;
        height: 48px;
        line-height: 48px;
        border: none;
        color: #737373;
        // padding-right: 90px;
      }
    }
    .search_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
      height: 48px;
      width: 84px;
      font-size: 14px;
      color: #FFFFFF;
      border: none;
      flex-shrink: 0;
    }
  }
  .temp_classi {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-top: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #EDEDED;
    .temp_classi_item {
      font-size: 16px;
      margin-left: 24px;
      // color: #EDEDED;
      cursor: pointer;
      position: relative;
      .temp_classi_del {
        display: none;
        position: absolute;
        top: -4px;
        right: -8px;
        border-radius: 50%;
        background: rgba(153, 153, 153, 0.46);
        font-size: 12px;
        width: 14px;
        height: 14px;
        line-height: 14px;
        text-align: center;
        color: #fff;
      }
      span {
        font-size: 14px;
        color: #CCCCCC;
      }
      &.active {
        // color: #FFFFFF;
        font-weight: 600;
      }
      &:hover {
        .temp_classi_del {
          display: block;
        }
      }
    }
    .temp_classi_add {
      padding: 5px 18px;
      border-radius: 24px;
      font-size: 12px;
      margin-left: 24px;
      border: 1px solid #BFBFBF;
      cursor: pointer;
    }
  }
  .table_tags {
    display: inline-block;
    font-size: 12px;
    border-radius: 18px;
    background: #3B4663;
    color: #FFFFFF;
    padding: 3px 10px;
    margin-left: 8px;
  }
  .form-uploader {
    height: 139px;
    border-radius: 8px;
    // background: #FFFFFF;
    padding: 13px 11px;
    border: 1px dashed #525459;
    color: #E0E0E0;
    /deep/ .el-upload {
      border-radius: 4px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed rgba(255, 255, 255, .6);
      .uploader_btn {
        color: #acaf0b;
        font-size: 12px;
        border-radius: 2px;
        width: 78px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border: 1px solid #acaf0b;
      }
    }
  }
}
.excel_dialog {
  /deep/ .el-dialog {
    color: #FFFFFF;
    margin-top: 5vh !important;
    height: 90vh;
    .el-dialog__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #595959;
      padding: 12px 24px 12px 64px;
      .temp_title {
        font-size: 20px;
        display: flex;
        align-items: center;
        .temp_platform {
          font-size: 14px;
          background: #acaf0b;
          color: #DCFF40;
          border: 1px solid #c9cc07;
          padding: 4px 8px 4px;
          line-height: 1;
          border-radius: 4px;
          margin-right: 14px;
        }
        .el-input__inner {
          background: transparent;
          color: #fff;
          border: 1px solid #5b5f68;
        }
        .el-icon-edit-outline {
          margin-top: 4px;
          margin-left: 8px;
          cursor: pointer;
        }
      }
      .submit_btn {
        color: #FFFFFF;
        border: none;
        background: linear-gradient(90deg, #4D95E8 0%, #2A82E4 100%);
      }
    }
    .el-dialog__body {
      padding: 0 24px 24px 64px;
      height: calc(100% - 88px);
      overflow: auto;
    }
    .excel_title {
      margin-bottom: 12px;
      // color: #FFFFFF;
      // &:not(:first-child) {
        margin-top: 24px;
      // }
    }
    .overall_box {
      display: flex;
      flex-wrap: wrap;
      color: #404040;
      gap: 12px 24px;
      .overall_value {
        color: #737373;
      }
    }
    .el-table {
      border: none;
      background: transparent;
      &::after, &::before {
        background: transparent;
      }
      .el-tag+.el-tag {
        // color: #3B4663;
        margin-left: 8px;
      }
      .el-textarea .el-textarea__inner {
        height: 48px;
      }
      .table_dy_box {
        display: flex;
        &.isImg .el-select .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: none;
        }
        .el-input-group {
          width: 72px;
          flex-shrink: 0;
          .el-input-group__prepend {
            border-left: none;
          }
          .el-input-group__append, .el-input-group__prepend {
            background: #FFFFFF;
            // border: none;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
            padding: 0;
            padding-right: 8px;
          }
          .el-input__inner {
            padding: 0;
            border-radius: 0;
            border-right: none;
            border-left: none;
            &:focus, &:hover {
              border-color: #DCDFE6;
            }
          }
        }
      }
    }
    .temp_table_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-dropdown {
        margin-left: 8px;
        color: #737373;
      }
    }
    .skutable_box {
      position: relative;
      .skutable_add {
        position: absolute;
        bottom: 4px;
        left: -48px;
        i {
          font-weight: 700;
        }
        
      }
    }
  }
}
.multiple_dialog {
  /deep/ .el-dialog {
    color: #FFFFFF;
    .el-dialog__header {
      display: none;
    }
    .el-dropdown {
      margin-bottom: 24px;
    }
    .multiple_item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .multiple_item_type {
        width: 100px;
        flex-shrink: 0;
        margin-right: 12px;
      }
      .multiple_item_c {
        flex: 1;
        &.isImg {
          display: flex;
          .el-select .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right: none;
          }
        }
        .el-input-group {
          width: 98px;
          flex-shrink: 0;
          .el-input-group__prepend {
            border-left: none;
          }
          .el-input-group__append, .el-input-group__prepend {
            background: #FFFFFF;
            padding: 0;
            padding-right: 12px;
          }
          .el-input__inner {
            padding: 0;
            border-radius: 0;
            border-right: none;
            border-left: none;
          }
        }
      }
      .multiple_item_del {
        margin-left: 24px;
        flex-shrink: 0;
        width: 30px;
        height: 30px;
        background: transparent;
        padding: 0;
        // color: #fff;
        border: 1px solid #525459;
      }
    }
  }
}
/deep/ ::-webkit-scrollbar {
  width: 5px !important;
  height: 6px !important;
  background-color: #ffffff00;
}

/deep/ ::-webkit-scrollbar-track {
  background-color: transparent;
  -webkit-border-radius: 1em;
  -moz-border-radius: 1em;
  border-radius: 1em;
}

/deep/ ::-webkit-scrollbar-track-piece {
  background-color: transparent;
  -webkit-border-radius: 1em;
  -moz-border-radius: 1em;
  border-radius: 1em;
}

/deep/ ::-webkit-scrollbar-thumb {
  background-color: #273764;
  -webkit-border-radius: 0.5em;
  -moz-border-radius: 0.5em; 
  border-radius: 1em;
}
</style>